/**
 * @description
 *
 * In AngularJS 1.x is a problem with translation via loading .json files from server.
 * Translation was working randomly and updating libs didn't help.
 * This file fix this problem by including all translations saved in .js files and assign them to output file application.js
 */

core.config([
    '$translateProvider',
    //PL
    'accountTranslationPL',
    'applicationTranslationPL',
    'baseOfCaseTranslationPL',
    'biTranslationPL',
    'highchartsTranslationPL',
    'loginTranslationPL',
    'patientTranslationPL',
    'paymentTranslationPL',
    'personalDataTranslationPL',
    'roleTranslationPL',
    'settingsTranslationPL',
    'subscriptionTranslationPL',
    'templateTranslationPL',
    'userTranslationPL',
    'visitTranslationPL',
    'accountMeedyTranslationPL',
    'alabMeedyTranslationPL',
    'applicationMeedyTranslationPL',
    'availabilityMeedyTranslationPL',
    'calendarMeedyTranslationPL',
    'deviceMeedyTranslationPL',
    'firstLoginMeedyTranslationPL',
    'invoiceMeedyTranslationPL',
    'loginMeedyTranslationPL',
    'messagesMeedyTranslationPL',
    'myDataMeedyTranslationPL',
    'officeMeedyTranslationPL',
    'opinionMeedyTranslationPL',
    'patientMeedyTranslationPL',
    'paymentMeedyTranslationPL',
    'remindPasswordMeedyTranslationPL',
    'roleMeedyTranslationPL',
    'secondDiagnosisMeedyTranslationPL',
    'userMeedyTranslationPL',
    'videoConsultationMeedyTranslationPL',
    'wizardMeedyTranslationPL',
    //EN

    function(
        $translateProvider,

        accountTranslationPL,
        applicationTranslationPL,
        baseOfCaseTranslationPL,
        biTranslationPL,
        highchartsTranslationPL,
        loginTranslationPL,
        patientTranslationPL,
        paymentTranslationPL,
        personalDataTranslationPL,
        roleTranslationPL,
        settingsTranslationPL,
        subscriptionTranslationPL,
        templateTranslationPL,
        userTranslationPL,
        visitTranslationPL,
        accountMeedyTranslationPL,
        alabMeedyTranslationPL,
        applicationMeedyTranslationPL,
        availabilityMeedyTranslationPL,
        calendarMeedyTranslationPL,
        deviceMeedyTranslationPL,
        firstLoginMeedyTranslationPL,
        invoiceMeedyTranslationPL,
        loginMeedyTranslationPL,
        messagesMeedyTranslationPL,
        myDataMeedyTranslationPL,
        officeMeedyTranslationPL,
        opinionMeedyTranslationPL,
        patientMeedyTranslationPL,
        paymentMeedyTranslationPL,
        remindPasswordMeedyTranslationPL,
        roleMeedyTranslationPL,
        secondDiagnosisMeedyTranslationPL,
        userMeedyTranslationPL,
        videoConsultationMeedyTranslationPL,
        wizardMeedyTranslationPL
        ) {


        var translationPL = _.merge(
            accountTranslationPL,
            applicationTranslationPL,
            baseOfCaseTranslationPL,
            biTranslationPL,
            highchartsTranslationPL,
            loginTranslationPL,
            patientTranslationPL,
            paymentTranslationPL,
            personalDataTranslationPL,
            roleTranslationPL,
            settingsTranslationPL,
            subscriptionTranslationPL,
            templateTranslationPL,
            userTranslationPL,
            visitTranslationPL,
            accountMeedyTranslationPL,
            alabMeedyTranslationPL,
            applicationMeedyTranslationPL,
            availabilityMeedyTranslationPL,
            calendarMeedyTranslationPL,
            deviceMeedyTranslationPL,
            firstLoginMeedyTranslationPL,
            invoiceMeedyTranslationPL,
            loginMeedyTranslationPL,
            messagesMeedyTranslationPL,
            myDataMeedyTranslationPL,
            officeMeedyTranslationPL,
            opinionMeedyTranslationPL,
            patientMeedyTranslationPL,
            paymentMeedyTranslationPL,
            remindPasswordMeedyTranslationPL,
            roleMeedyTranslationPL,
            secondDiagnosisMeedyTranslationPL,
            userMeedyTranslationPL,
            videoConsultationMeedyTranslationPL,
            wizardMeedyTranslationPL
        );

        /*const translationEN = _.merge(

        );*/

        $translateProvider.translations('pl_PL', translationPL);
        // $translateProvider.translations('en_US', translationEN);
    }
]);
